// extracted by mini-css-extract-plugin
export default {"title":"AllInOneYearlyFees_title__cUTcg","copyButton":"AllInOneYearlyFees_copyButton__iMgs5","copyIcon":"AllInOneYearlyFees_copyIcon__uO+ya"};